interface Props {
  lastUpdated: Date | null;
  isLoading: boolean;
  onRefresh: () => void;
}

export function PulseHeader({ lastUpdated, isLoading, onRefresh }: Props) {
  return (
    <>
    <div className="relative overflow-hidden mb-4 sm:mb-6">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1920&q=80)`,
          filter: "blur(2px)",
          transform: "scale(1.1)",
        }}
      />
      {/* Gradient overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-surface-950/80 via-surface-950/50 to-surface-950/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-surface-950/90 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-10">
        <div>
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-surface-100 flex items-center gap-3 animate-fade-in">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-3 w-3 bg-accent-400" />
            </span>
            Pulse
          </h1>
          <p className="text-sm sm:text-base text-surface-300 mt-1.5 animate-fade-in" style={{ animationDelay: "100ms" }}>
            Real-time market intelligence &mdash; indices, sectors, commodities, crypto & more
          </p>
        </div>
      </div>
    </div>

    {/* Control bar below header */}
    <div className="px-4 sm:px-6 lg:px-8 -mt-2 mb-4 flex items-center justify-between">
      <div className="flex items-center gap-2">
        {lastUpdated && (
          <span className="text-xs text-surface-400">
            Last updated {lastUpdated.toLocaleTimeString()}
          </span>
        )}
        {isLoading && (
          <span className="flex items-center gap-1.5 text-xs text-primary-400">
            <svg className="animate-spin h-3 w-3" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
            </svg>
            Refreshing...
          </span>
        )}
      </div>
      <button
        onClick={onRefresh}
        disabled={isLoading}
        className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg bg-surface-800/60 border border-surface-700/50 text-surface-300 hover:text-surface-100 hover:bg-surface-800 hover:border-surface-600/50 transition-colors disabled:opacity-50"
      >
        <svg
          className={`w-3.5 h-3.5 ${isLoading ? "animate-spin" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        Refresh All
      </button>
    </div>
    </>
  );
}
